import { EventEmitter, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ApplicationHostTypeService } from 'rome-library';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private readonly headerTitle$ = new BehaviorSubject('');
  public IsOnlineOfferState = false;
  public closeSessionEvent$ = new EventEmitter();
  public refreshMakePaymentEvent$ = new EventEmitter();

  public showUnauthenticatedHeader: boolean;
  public isHelpCentreLinkVisible: boolean;
  public isMakePaymentContext = false;

  constructor(public router: Router, public readonly applicationHostTypeService: ApplicationHostTypeService) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((_event: NavigationEnd) => {
      this.resetHeaderTitle();
      this.resetOnlineOfferContext();
    });
    this.isHelpCentreLinkVisible = this.applicationHostTypeService.isDirectInterfaceType();
  }

  public getHeaderTitle(): BehaviorSubject<string> {
    return this.headerTitle$;
  }

  public setHeaderTitle(title: string): void {
    this.headerTitle$.next(title);
    this.showUnauthenticatedHeader = true;
  }

  public resetHeaderTitle(): void {
    this.headerTitle$.next(undefined);
    this.showUnauthenticatedHeader = false;
  }

  public setOnlineOfferContext(): void {
    this.IsOnlineOfferState = true;
  }

  private resetOnlineOfferContext(): void {
    this.IsOnlineOfferState = false;
  }

  public setMakePaymentContext(): void {
    this.isHelpCentreLinkVisible = false;
    this.isMakePaymentContext = true;
    this.setHeaderTitle('');
  }
}
